import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import * as actions from '../../action-creators';
import { api, apiV3, callFunctionWhenPropsChange } from '../../lib';
import * as selectors from '../../selectors';
import { array, collections } from '../../utils';

import { enterUserApp } from '../terminal-time-tracking/utils';
import Organism from './organism';
import { loadTimeTrackingInformationForMember } from './utils';

const { sortByKey } = array;
const { composeReverse } = collections;

const { signOutUser, v3SignOutUser, loadTerminalCrewMembers } = actions;
const { selectTerminalCrewMembersInCurrentCrew } = selectors;

const mapStateToProps = (state, props) => ({
  ...props,
  members: sortByKey(selectTerminalCrewMembersInCurrentCrew(state, props), 'id'),
});

const mapDispatchToProps = (dispatch, ownProps) => {
  const dispatchLoadTerminalCrewMembers = () =>
    dispatch(loadTerminalCrewMembers.unmemoized({ api, crewId: ownProps.crewId, disabledAt: null }));

  return {
    functionToCall: () => {
      if (ownProps.crewId) dispatchLoadTerminalCrewMembers();
    },
    enterUserApp: enterUserApp(dispatch),
    loadTerminalCrewMembers: dispatchLoadTerminalCrewMembers,
    loadTimeTrackingInformation: (member) => loadTimeTrackingInformationForMember(dispatch, { ...ownProps, member }),
    signOutUser: () => {
      dispatch(signOutUser({ api, clearCache: false }));
      dispatch(v3SignOutUser({ apiV3 }));
    },
  };
};

const TerminalPinCode = composeReverse(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  callFunctionWhenPropsChange({ propNamesTriggeringFunctionCall: ['crewId'] })
)(Organism);

export default TerminalPinCode;
